import React, {useEffect} from 'react';
import './App.css';
import Content from './Content'
import { BrowserRouter as Router } from 'react-router-dom';
import { ReactNotifications } from 'react-notifications-component'
import icon from './icon-cugatetv.svg'


function App() {

  useEffect(() => {
      const favicon = document.getElementById('favicon');
      favicon.setAttribute('href', icon);
  }, []);

  useEffect(() => {
      if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'manual';
      }
  }, []);

  return (
    <Router>
      <div className="position-relative d-flex flex-column "
      >
        <ReactNotifications />
        <Content/>
      </div>
    </Router>
  )
}

export default App